/**
 * @generated SignedSource<<b217a1d9c8dc35c18383ed8fd0a640e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendGuestMessageInput = {
  emailMessageInput: SendEmailMessageInput;
  guestMembershipIds: ReadonlyArray<string>;
  organizationId: string;
};
export type SendEmailMessageInput = {
  richEditorBody: string;
  subject: string;
};
export type MessageCommunityGuestsDrawerMutation$variables = {
  input: SendGuestMessageInput;
};
export type MessageCommunityGuestsDrawerMutation$data = {
  readonly response: {
    readonly automation: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type MessageCommunityGuestsDrawerMutation = {
  response: MessageCommunityGuestsDrawerMutation$data;
  variables: MessageCommunityGuestsDrawerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendGuestMessageResponse",
    "kind": "LinkedField",
    "name": "sendGuestMessage",
    "plural": false,
    "selections": [
      {
        "alias": "automation",
        "args": null,
        "concreteType": "Automation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageCommunityGuestsDrawerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageCommunityGuestsDrawerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "56d5c85a72725cecdadf4a9562708257",
    "id": null,
    "metadata": {},
    "name": "MessageCommunityGuestsDrawerMutation",
    "operationKind": "mutation",
    "text": "mutation MessageCommunityGuestsDrawerMutation(\n  $input: SendGuestMessageInput!\n) {\n  response: sendGuestMessage(input: $input) {\n    automation: node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f44c0589772b4be64c91e35f0f847814";

export default node;
